import { REPORT_TO, type ReportToEntry } from "./report-to"
import { PLATFORMS } from "./platforms"

export type DirectoryId = "report" | "platforms" | "individuals" | "ir-guidance" | "lawyers" | "insurance"

export interface DirectoryInfo { id: DirectoryId; href: string; title: string; blurb: string }

/** The resource hub. Order is the order shown. */
export const DIRECTORIES: DirectoryInfo[] = [
  { id: "report", href: "/directory/report", title: "Who to report to", blurb: "Law enforcement, regulators, and card-industry contacts, with each deadline clock linked to where it is filed." },
  { id: "platforms", href: "/directory/platforms", title: "Platform incident contacts", blurb: "How to report a compromise, recover an account, and get logs from Microsoft 365, Google Workspace, AWS, and other common platforms." },
  { id: "lawyers", href: "/find-a-lawyer", title: "Find a breach lawyer", blurb: "Check your insurance first, use a bar referral service, or review firms that advertise breach response." },
  { id: "insurance", href: "/insurance", title: "Cyber insurance directory", blurb: "Find your insurer's claims contact, or learn how to get cover after a breach." },
  { id: "ir-guidance", href: "/directory/ir-guidance", title: "Choosing an incident-response firm", blurb: "Neutral guidance, official lists, how insurers handle approved vendors, and questions to ask before you sign." },
  { id: "individuals", href: "/directory/individuals", title: "For affected individuals", blurb: "Official resources for people whose data was exposed, and what a business can point them to." },
]

/** Which directories help at each runbook step (shown on the step's Wrap up page). */
export const STEP_DIRECTORIES: Record<string, DirectoryId[]> = {
  start: ["lawyers", "insurance", "ir-guidance"],
  triage: ["platforms", "report"],
  assemble: ["lawyers", "ir-guidance"],
  contain: ["platforms", "report"],
  investigate: ["platforms", "ir-guidance", "report"],
  eradicate: ["platforms", "ir-guidance"],
  notify: ["report", "lawyers", "insurance", "individuals"],
  recover: ["platforms", "ir-guidance"],
  learn: ["ir-guidance", "individuals"],
}

export function directoriesForStep(stepId: string): DirectoryInfo[] {
  const ids = STEP_DIRECTORIES[stepId] ?? []
  return ids.map((id) => DIRECTORIES.find((d) => d.id === id)).filter((d): d is DirectoryInfo => !!d && (d.id !== "platforms" || PLATFORMS.length > 0))
}

/** Where to file for a deadline clock (clock ids come from lib/breach/deadlines.ts). */
export function reportDestinationsFor(clockId: string): ReportToEntry[] {
  return REPORT_TO.filter((e) => e.clockIds.includes(clockId))
}

/** In-site anchor for a report-to entry. */
export const reportAnchor = (id: string) => `/directory/report#${id}`
